/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateRangeValue } from './date-range-value';
import { KpiValueFormat } from './kpi-value-format';
import { ChartConfigurationSchema } from './chart-configuration-schema';
import { ResultMetadataSchema } from './result-metadata-schema';
import { TrendPlan } from './trend-plan';
import { ValidationIssueSchema } from './validation-issue-schema';


export interface MetricArtifact { 
    _id: string;
    programId: string;
    ownerUserId: string;
    /**
     * Short human-readable title for the artifact.
     */
    title?: string;
    question?: string;
    type: MetricArtifact.TypeEnum;
    /**
     * How a trend artifact\'s values are formatted; null for every other type.
     */
    valueFormat?: KpiValueFormat | null;
    sql: string;
    chartConfig: ChartConfigurationSchema | null;
    usedTables: Array<string>;
    usedColumns: Array<string>;
    validationStatus: MetricArtifact.ValidationStatusEnum;
    validationIssues: Array<ValidationIssueSchema>;
    resultMetadata: ResultMetadataSchema;
    /**
     * The rows the SQL returned: the first 100, or all of a trend\'s buckets.
     */
    resultSample: Array<object>;
    /**
     * The dates the artifact covers, resolved when it was created (a trend\'s before widening); null when none was given.
     */
    period?: DateRangeValue | null;
    /**
     * A trend artifact\'s plan, as a trend tile returns it: read resultSample rows by the first 10 characters of bucket. Null for every other type.
     */
    trend?: TrendPlan | null;
}
export namespace MetricArtifact {
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const ValidationStatusEnum = {
        Valid: 'valid',
        Invalid: 'invalid'
    } as const;
    export type ValidationStatusEnum = typeof ValidationStatusEnum[keyof typeof ValidationStatusEnum];
}


